import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/sharp-solid-svg-icons";

import styles from "./form-field-error.module.scss";

interface FormFieldErrorProps {
  error: string;
}

export const FormFieldError = ({ error }: FormFieldErrorProps) => (
  <>
    <FontAwesomeIcon icon={faCircleExclamation} className={styles.errorIcon} />
    <span className={styles.errorText}>{error}</span>
  </>
);
